import styled from 'styled-components'
import { media } from '../../../utils'

const WizardContainer = styled.div`
  display: grid;
  grid-template-areas:
    'top     top        top'
    'spacing spacing    spacing'
    'leftTop wizard     rightTop'
    'leftBot navigation rightBot'
    'bottom  bottom     bottom';
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-rows: 0.6fr auto minmax(400px, 3fr) auto 1fr;
  grid-row-gap: 30px;
  width: 100%;
  min-height: 100vh;
  background-color: #d5e4e6;

  ${media.desktop`
    grid-template-columns: 1fr 5fr 1fr;
  `}
  ${media.tablet`
    grid-template-columns: .5fr 10fr .5fr;
    grid-template-rows: minmax(100px, 1fr) auto auto auto 1fr;
  `}
  ${media.phone`
    grid-template-rows: 70px 5fr 1fr 50px;
    grid-template-rows: minmax(80px, 1fr) auto auto auto 1fr;
  `}
`

export const QuickWizardLoadingGrid = styled.div`
  display: grid;
  grid-template-areas:
    'top     top        top'
    'spacing spacing    spacing'
    'leftTop loading     rightTop'
    'bottom  bottom     bottom';
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-rows: 100px 0.75px minmax(400px, auto) 1fr;
  width: 100%;
  min-height: 75vh;
  padding: 7.5px;
  padding-bottom: 0;
  background-color: #dbe6e9;
  font-weight: bold;
  overflow: hidden;

  ${media.desktop`
    grid-template-columns: 1fr 5fr 1fr;
  `}
  ${media.tablet`
    grid-template-columns: 0fr 1fr 0fr;
    grid-template-rows: 100px auto auto 1fr;
  `}
  ${media.phone`
    grid-template-rows: 80px auto auto 1fr;
  `}
`

export const WizardContactGrid = styled.div`
  display: grid;
  grid-template-areas:
    '. info info info .'
    '. slider slider slider .'
    '. content content sidebar .'
    '. form-info form-info sidebar .'
    '. opinions opinions opinions .'
    '. footer footer footer .';
  grid-template-columns: 1fr 310px 310px minmax(150px, 320px) 1fr;
  grid-gap: 30px;
  padding-top: 83px;
  width: 100%;
  min-height: 100vh;
  background-color: #d5e4e6;

  ${media.giant`
    grid-template-areas:
      '. info .'
      '. content .'
      '. form-info .'
      '. slider .'
      '. sidebar .'
      '. opinions .'
      '. footer .';
    grid-template-columns: 15px 1fr 15px;
    grid-gap: 15px;
  `}
`
export default WizardContainer



// WEBPACK FOOTER //
// ./src/components/containers/wizard/WizardContainer.tsx